import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Homepage from './pages/Homepage';
import Checkout from './pages/Checkout';
import Success from './pages/Success';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Invest from './pages/Invest';
import InsertConfigurationOfficePublic from './pages/InsertConfigurationOfficePublic';
import SkipresApp from './final/SkipresApp';
import './App.css';

// Helper to check if running as native app
const isNativePlatform = () => {
  try {
    // Check if Capacitor is available and we're on a native platform
    const Capacitor = window.Capacitor;
    return Capacitor && Capacitor.isNativePlatform && Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

function App() {
  const [isNative] = useState(() => isNativePlatform());

  // If native app, go directly to marketplace (no Router needed)
  if (isNative) {
    return (
      <ThemeProvider>
        <AuthProvider>
          <SkipresApp />
        </AuthProvider>
      </ThemeProvider>
    );
  }

  // Web version with all routes
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/success" element={<Success />} />
            <Route path="/registrazione" element={<InsertConfigurationOfficePublic />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/:tab" element={<AdminDashboard />} />
            <Route path="/app/*" element={<SkipresApp />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
